module.exports = __webpack_public_path__ + "static/media/scene1.5e549d27.jpg";